module.exports = __webpack_public_path__ + "img/src/components/ListPopularLocationCoverPhoto/large_no_image.jpeg?5389cfdd";